import React from 'react';
import ContentLoader from 'react-content-loader';

const InsightsLoader = () => (
  <ContentLoader
    height={900}
    width={1200}
    speed={1}
    primaryColor={"#ccc"}
    secondaryColor={"#DCDCDC"}
  >
    <rect id="Rectangle" x="899" y="105" width="301" height="533" rx="3"></rect>
    <rect id="Rectangle" x="0" y="105" width="859" height="156" rx="3"></rect>
    <rect id="Rectangle" x="0" y="301" width="859" height="229" rx="3"></rect>
    <rect id="Rectangle" x="959" y="30" width="241" height="25" rx="3"></rect>
    <rect id="Rectangle" x="0" y="30" width="653" height="25" rx="3"></rect>
  </ContentLoader>
);

export default InsightsLoader;



// WEBPACK FOOTER //
// ./src/components/common/loaders/insights-loader.js